module.exports = __webpack_public_path__ + "static/0023-d55b9c97d5ae7b7d04899b338d02dae2.png";